import {BaseService} from "./BaseService";
import {ApiResponse} from "../../shared/models/ApiResponse";

export class MagazineService extends BaseService {
    /**
     * search articles.
     */
    async searchArticles(search: string, limit: number) {
        return new Promise<ApiResponse>((resolve, reject) => {
            fetch('/wp-json/erl-api/v1/magazine/search-articles', {
                method: 'POST',
                headers: this.apiHeaders,
                body: JSON.stringify({
                    search: search,
                    limit: limit
                })
            })
                .then(res => this.factoryApiResponse(res)).then((apiResponse: any) => {
                if (apiResponse.success) {
                    resolve(apiResponse);
                } else {
                    reject(null);
                }
            })
                .catch(reject);
        });
    }

    /**
     * get articles.
     */
    async getArticles(articleIds: number[], limit: number) {
        return new Promise<ApiResponse>((resolve, reject) => {
            fetch('/wp-json/erl-api/v1/magazine/get-articles', {
                method: 'POST',
                headers: this.apiHeaders,
                body: JSON.stringify({
                    articleIds: articleIds,
                    limit: limit
                })
            })
                .then(res => this.factoryApiResponse(res)).then((apiResponse: any) => {
                if (apiResponse.success) {
                    resolve(apiResponse);
                } else {
                    reject(null);
                }
            })
                .catch(reject);
        });
    }
}
